import React from "react";

import { Box, Typography } from "@mui/material";
import { format } from "date-fns";
import { makeStyles } from "tss-react/mui";

import { MealRating } from "@/gql/graphql";
import { humanize } from "@/utils/string";

import MealRatingIcon from "../../../ClientDiary/Meals/components/MealRatingIcon";

const useStyles = makeStyles()(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    padding: 15,
  },
  text: {
    fontFamily: "Mulish",
    color: "#4C515A",
    fontSize: 14,
  },
}));

interface MealRatingLogsItemProps {
  mealRating: MealRating;
}

const MealRatingLogsItem: React.FC<MealRatingLogsItemProps> = ({
  mealRating,
}) => {
  const { classes } = useStyles();

  const { rating, mealType, consumedOn, consumedAt } = mealRating;
  const consumedDate = `${consumedOn} ${consumedAt}`;
  const formattedDate = format(new Date(consumedDate), "dd LLL, KK:mm aa");

  return (
    <Box className={classes.container}>
      <MealRatingIcon rating={rating} />
      <Box width={16} />
      <Box>
        <Typography className={classes.text} fontWeight={700}>
          {humanize(mealType)}
        </Typography>
        <Typography className={classes.text} fontWeight={600}>
          {formattedDate}
        </Typography>
      </Box>
    </Box>
  );
};

export default MealRatingLogsItem;
